export const KAKAO_MAP_TYPE_ID = {
  ROADMAP: 1,
  USE_DISTRICT: 10,
};
